<template>
  <a
  class="sprite-button"
  :href="href"
  :style="style()"
  @click="$emit('click')"
  ></a>
</template>

<script>
export default {
  props: [
    'href',
    'background-url',
    'width',
    'height',
  ],
  methods: {
    style () {
      return {
        'background-image': `url(${this.backgroundUrl})`,
        width: this.width,
        height: this.height,
        'background-size': this.width + ' calc(2*' + this.height + ')'
      }
    }
  }
}
</script>

<style lang="less">
.sprite-button {
  display: block;
  background-position: top left;
  background-repeat: no-repeat;
  border: 0px;
  border-radius: 0px;
  margin: 0px 0px;
  opacity: 1;
  &:active {
    background-position: bottom left;
  }
}
</style>